module.exports = __webpack_public_path__ + "img/1-2.9a845d67.png";